const DEFAULT_MESSAGE = 'Falha na operação.'

export const getApiErrorMessage = (data, fallback = DEFAULT_MESSAGE) => {
  if (!data) return fallback

  if (Array.isArray(data.messages) && data.messages.length) {
    return data.messages.join(', ')
  }

  if (typeof data.message === 'string') return data.message
  if (typeof data.error === 'string') return data.error

  return fallback
}

export const throwApiError = (res, fallback = DEFAULT_MESSAGE) => {
  const message = getApiErrorMessage(res.data, res.problem || fallback)
  const error = new Error(typeof message === 'string' ? message : fallback)
  error.status = res.status
  error.data = res.data
  throw error
}
